angular.module('dpw.components')
/**
 * @ngdoc directive
 * @name dpwSpaLinks
 * @restrict A
 * @description
 * Convert links in existing pages that are not using SPA style.
 * @example
 * <div dpw-spa-links>
 *     <a href="api-and-docs.html/#message">Messages</a>
 * </div>
 * <div dpw-spa-links>
 *     <a href="api-and-docs.html/messages.html">Messages</a>
 * </a>
 */
    .directive('dpwSpaLinks', [
        '$location', '$anchorScroll', 'helpers',
        function ($location, $anchorScroll, helpers) {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    element.find('a').on('click', function (event) {
                        if (helpers.isEmailLink(this.href)) {
                            angular.element(this).attr('target', '_self');
                            return;
                        }

                        helpers.isExternalLink(this.href) ?
                            angular.element(this).attr('target', '_blank') :
                            handlerForInternalLink(this.href, event);
                    });

                    function handlerForInternalLink(href, event) {
                        var hashPosition = href.lastIndexOf('#');
                        var lastSlashPosition = href.lastIndexOf('/');
                        var anchorName;

                        // First, try to use anchor in the href.
                        if (hashPosition > -1) {
                            anchorName = href.substring(hashPosition + 1);
                            if (isTargetExists(anchorName)) {
                                event.preventDefault();
                                locate(anchorName);
                                return;
                            }
                        }

                        // Use basename.html/base.htm when anchor location failed.
                        if (lastSlashPosition > -1) {
                            anchorName = href.substring(lastSlashPosition + 1);
                            var isHtml = anchorName.indexOf('.html') > -1;
                            var isHtm = anchorName.indexOf('.htm') > -1;
                            var startPoint = lastSlashPosition + 1;

                            if (isHtml || isHtm) {
                                anchorName = href.substring(startPoint, getEndpoint());
                                if (isTargetExists(anchorName)) {
                                    event.preventDefault();
                                    locate(anchorName);
                                }
                            }
                        }

                        function getEndpoint() {
                            return startPoint + (isHtml ?
                                anchorName.indexOf('.html') + 5 :
                                anchorName.indexOf('.htm') + 4);
                        }

                        function locate(anchorName) {
                            $location.hash(anchorName);
                            $anchorScroll();
                        }

                        function isTargetExists(targetHook) {
                            var result;

                            try {
                                result = document.querySelector('#' + targetHook.replace('.', '\\.')) ||
                                    document.querySelector('[name="' + targetHook + '"');
                            } catch (e) {
                            }

                            return result;
                        }
                    }
                }
            };
        }
    ]);
